import { map } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService, WindowProxy } from '@sm360/widget-commons-core-services';

import TRANSACTION from 'login/constants/transaction.js';
import TransactionAction from 'login/components/Transaction/TransactionAction/TransactionAction.jsx';
import TransactionActionTrade360 from 'login/components/Transaction/TransactionAction/TransactionActionTrade360.jsx';
import { AnalyticsService, AdobeService, ADOBE_TAGS, CONSTANT } from '@sm360/widget-commons-general';
import TAGS from 'login/constants/trackingTags';

class TransactionActions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            actionsOpen: {
                garage: false,
                tradein: false,
                finance: false,
                reserve: false,
            },
        };
        this.onActionOpen = this.onActionOpen.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.showTransactionDetails) {
            this.setState({
                actionsOpen: {
                    garage: false,
                    tradein: false,
                    finance: false,
                    reserve: false,
                },
            });
        }
    }

    onActionOpen(slug) {
        if (this.props.hasAdobeTagging) {
            if (this.state.actionsOpen[slug] === false) {
                if (slug === CONSTANT.TRANSACTION.GARAGE.TITLE) {
                    AdobeService.eventTrigger(ADOBE_TAGS.GARAGE_TRANSACTION_BAR(), 'global-overlay');
                }
                if (slug === CONSTANT.TRANSACTION.TRADEIN.TITLE) {
                    AdobeService.eventTrigger(
                        ADOBE_TAGS.TRADE_IN_TRANSACTION_BAR(this.props?.vehicleTradein),
                        'global-overlay'
                    );
                }
            }
        }
        const trackingTag = TAGS[`MY_TRANSACTION__${slug.toUpperCase()}`];
        if (trackingTag && trackingTag.call && this.state.actionsOpen[slug] === false) {
            AnalyticsService.gaTrigger(trackingTag(WindowProxy.location().pathname));
        }
        const newActionsOpen = {};
        Object.keys(this.state.actionsOpen).forEach((currentSlug) => {
            if (currentSlug === slug && this.state.actionsOpen[currentSlug] === false) {
                newActionsOpen[currentSlug] = true;
            } else {
                newActionsOpen[currentSlug] = false;
            }
        });

        this.setState({ actionsOpen: newActionsOpen });
    }

    render() {
        const actions = map(TRANSACTION, (itemSlug, key) => {
            return itemSlug.label === 'tradein' ? (
                <TransactionActionTrade360
                    key={key}
                    itemSlug={itemSlug.label}
                    garageCount={itemSlug.label === 'garage' ? this.props.completedSteps.garageCount : 0}
                    onCloseTransactionAction={this.props.onCloseTransactionAction}
                    isCompleted={this.props.completedSteps[itemSlug.label]}
                    tradeInAmount={this.props.completedSteps.tradeInAmount}
                    tradeInTaxCredits={this.props.completedSteps.tradeInTaxCredits}
                    stateActionsOpen={this.state.actionsOpen}
                    onActionOpen={this.onActionOpen}
                    isNewEnabled={this.props.isNewEnabled}
                    isUsedEnabled={this.props.isUsedEnabled}
                    usedUrl={this.props.usedUrl}
                    timeSaved={itemSlug.timeSaved}
                    vehicleTradein={this.props.vehicleTradein}
                    isAuthenticated={this.props.isAuthenticated}
                    loginClick={this.props.loginClick}
                    deleteTradeIn={this.props.deleteTradeIn}
                    isMultiDealerGarage={!!this.props?.isMultiDealerGarage}
                    hasAdobeTagging={this.props.hasAdobeTagging}
                />
            ) : (
                <TransactionAction
                    key={key}
                    itemSlug={itemSlug.label}
                    garageCount={itemSlug.label === 'garage' ? this.props.completedSteps.garageCount : 0}
                    onCloseTransactionAction={this.props.onCloseTransactionAction}
                    isCompleted={this.props.completedSteps[itemSlug.label]}
                    tradeInAmount={this.props.completedSteps.tradeInAmount}
                    tradeInTaxCredits={this.props.completedSteps.tradeInTaxCredits}
                    stateActionsOpen={this.state.actionsOpen}
                    onActionOpen={this.onActionOpen}
                    isNewEnabled={this.props.isNewEnabled}
                    isUsedEnabled={this.props.isUsedEnabled}
                    usedUrl={this.props.usedUrl}
                    timeSaved={itemSlug.timeSaved}
                    vehicleTradein={this.props.vehicleTradein}
                    isAuthenticated={this.props.isAuthenticated}
                    loginClick={this.props.loginClick}
                    deleteTradeIn={this.props.deleteTradeIn}
                    isMultiDealerGarage={!!this.props?.isMultiDealerGarage}
                    hasAdobeTagging={this.props.hasAdobeTagging}
                    displayCreditRate={this.props.displayCreditRate}
                />
            );
        });
        return (
            <div className="TransactionAction--wrapper sr-text" role="region" aria-label="actions">
                <span className="sr-text is-bold transaction-title">
                    {LocaleService.t('TRANSACTION_PROGRESSION.MY_ACTIONS')}
                </span>
                {actions}
            </div>
        );
    }
}

TransactionActions.defaultProps = {
    completedSteps: {
        garageCount: 0,
        garage: false,
        tradein: false,
        finance: false,
        reserve: false,
    },
    hasAdobeTagging: false,
    displayCreditRate: false,
};

TransactionActions.propTypes = {
    completedSteps: PropTypes.shape({
        garageCount: PropTypes.number.isRequired,
        garage: PropTypes.bool.isRequired,
        tradein: PropTypes.bool.isRequired,
        reserve: PropTypes.bool.isRequired,
        finance: PropTypes.bool.isRequired,
        tradeInAmount: PropTypes.number.isRequired,
        tradeInTaxCredits: PropTypes.number.isRequired,
    }),
    showTransactionDetails: PropTypes.bool.isRequired, // eslint-disable-line react/no-unused-prop-types
    onCloseTransactionAction: PropTypes.func.isRequired,
    isNewEnabled: PropTypes.bool.isRequired,
    isUsedEnabled: PropTypes.bool.isRequired,
    usedUrl: PropTypes.string.isRequired,
    vehicleTradein: PropTypes.shape({
        tradeId: PropTypes.string.isRequired,
        make: PropTypes.string.isRequired,
        model: PropTypes.string.isRequired,
        modelTrim: PropTypes.string.isRequired,
        year: PropTypes.number.isRequired,
        odometer: PropTypes.number.isRequired,
        retail: PropTypes.number.isRequired,
        amount: PropTypes.number.isRequired,
        officialAmount: PropTypes.number.isRequired,
        officialAmountExp: PropTypes.number.isRequired,
    }).isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    loginClick: PropTypes.func.isRequired,
    deleteTradeIn: PropTypes.func.isRequired,
    isMultiDealerGarage: PropTypes.bool.isRequired,
    hasAdobeTagging: PropTypes.bool,
    displayCreditRate: PropTypes.bool,
};

TransactionActions.displayName = 'TransactionActions';

export default TransactionActions;
